module.exports = __webpack_public_path__ + "source-sans-pro-v11-latin-600-08fdd6f1e8fe8a4f9ae63d28046a3ac7.bundle.woff";